/**
 * Collection Dashboard V1 — operator-facing copy (Slice C).
 */

export const COLLECTION_DASHBOARD_OPERATOR_LABELS = {
  pageTitle: '수금 관리 대시보드',
  pageSubtitle: '케이스·큐·검토·리스크 지표를 한 화면에서 확인하고 상세 화면으로 이동합니다.',
  permissionUnavailable:
    '수금 관리 대시보드 조회 권한이 없습니다. 관리자에게 collection_dashboard:read 권한을 요청하세요.',
  loadFailed: '수금 관리 대시보드를 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
  aggregateUnavailable: '대시보드 집계를 일시적으로 사용할 수 없습니다.',
  retry: '다시 시도',
  refresh: '새로고침',
  generatedAt: '생성 시각',
  asOf: '기준 시각',
  freshnessLabel: '집계 신선도',
  freshnessCurrent: '최신(요청 시 도출)',
  freshnessPartial: '부분 집계(선택 소스 실패)',
  freshnessFailed: '필수 소스 실패 — 수치를 확정 진실로 취급하지 마세요',
  freshnessUnknown: '신선도 불명',
  freshnessSuperseded: '정의 버전 교체됨',
  freshnessStale: '스테일',
  freshnessRebuilding: '재구축 중',
  authorityDerivedAnalytical: '파생 분석 집계(비권한)',
  warningsTitle: '일부 섹션을 불러오지 못했습니다',
  sectionCaseWorkload: '케이스 업무량',
  sectionRecommendationWorkload: '추천 업무량',
  sectionReviewWorkload: '검토 업무량',
  sectionOperationalRisk: '운영 리스크',
  openCases: '진행 중 케이스',
  stageActiveRecommendations: '단계 추천(활성)',
  exceptionVisible: '표시 예외',
  pendingManagerReview: '관리자 검토 대기',
  creditHoldActive: '신용 보류(활성)',
  creditHoldDeferred: '신용 보류(유예)',
  frpActive: '최종 요청 준비(활성)',
  frpDeferred: '최종 요청 준비(유예)',
  creditReviewOpen: '신용 검토(미배정 포함)',
  creditReviewAssigned: '신용 검토(배정)',
  creditReviewDeferred: '신용 검토(유예)',
  creditReviewUnassigned: '신용 검토(미배정)',
  brokenCommitment: '약속 불이행',
  overdueBucket: '연체 버킷',
  activeLegalPrep: '법무 준비 플래그',
  drillDownUnavailable: '상세 화면 권한 없음',
  emptyTenant: '표시할 수금 관리 지표가 없습니다.',
  queuesLink: '수금 관리 큐 열기 →',
  enforcementLink: '수금 Enforcement 열기 →',
} as const;
